// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_header-module--container--2cvgz"};